module.exports = __webpack_public_path__ + "static/media/icon_motion-sensor.88bc1014.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon_motion-sensor.svg
// module id = 88
// module chunks = 0